<template lang="html">
  <div class="topicPost">
    <ShareHeader :openTarget="'topicPost/detail?id=' + tid" />
    <!-- 话题 -->
    <div class="topicCard">
      <p class="topicTitle">{{topicInfo.topic_name}}</p>

      <div class="topicConAll">
        <div id="topicContent" class="topicContent" :class="{'topicContentShow': show}" v-html="supplement"></div>
        <div class="showArticle" v-show="articleBtnShow" @click="articleBtn()">
          <span>阅读全文</span>
          <img :src="`${pagebase}/static/img/emc/all.png`" alt="">
        </div>
      </div>

      <div class="topicFounder">
        <p class="founderHeader">
          <img :src="topicInfo.avatar" alt="">
          <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + topicInfo.uid" />
        </p>
        <p class="founderName">{{topicInfo.username}}</p>
        <p>·</p>
        <p class="founderTexe">发布话题</p>
      </div>

      <div class="likeNum">
        <p class="viewNum">{{topicInfo.viewnumber}} <span class="likeText">浏览</span></p>
        <span>·</span>
        <p class="joinNum">{{topicInfo.joinnumber}} <span class="likeText">参与</span></p>
        <span>·</span>
        <p class="followingNum">{{topicInfo.following_num}} <span class="likeText">关注</span></p>
      </div>
    </div>

    <div class="postCon">
      <p class="allTopicNum">{{topicInfo.post_num}}篇讨论贴</p>
      <div class="singleTopicCon">
        <div class="userInformation">
          <p class="userHeader">
            <img :src="invitationInfo.avatar" alt="">
            <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + invitationInfo.uid" />
          </p>
          <p class="userText">
            <span class="userName">{{invitationInfo.username}}</span>
            <span class="userTime">{{invitationInfo.createdate}}</span>
          </p>
        </div>

        <div class="postSingleCon" :class="{allPost: cur}" v-html="content"></div>

        <div class="postMore" v-show="moreBtn" @click="postMore">
          查看更多
        </div>
      </div>
    </div>

    <div class="shadeMod" v-show="shadeShow">
      <div class="callAppMod">
        <img src="../../assets/image/topic/close.png" alt="" class="closeBtn" @click="closeShade">
        <div class="shadeCon">
          <img src="../../assets/image/topic/imgNo1.png" alt="">
          <p>打开电巢APP，体验全量功能哦~</p>
          <button class="callAppBtn" type="button">
            打开电巢APP
            <WxOpenTag ref="wxopentag" :extinfo="'topicPost/detail?id=' + tid" />
          </button>
        </div>
      </div>
    </div>

    <!-- 评论 -->
    <div class="commentCon">
      <p class="commentAll">
        <span class="commentText">全部评论</span>
        <span class="commentLength">({{commentInfon.length}}条)</span>
      </p>
      <div class="commentList" v-for="(b, index) in commentInfon" :key="index">
        <img class="commentHeader" :src="b.avatar" alt="">
        <div class="commentAllCon">
          <div class="conLeft">
            <p class="commentTitle">{{b.username}}</p>
            <p class="commentContent">{{b.comment}}</p>
            <p class="commentReply">
              <span class="commentTime">{{b.createdate}}·</span>
              <span class="commentTimeText">回复Ta</span>
            </p>
            <p class="commentElse">
              <span>查看{{1}}条评论</span>
              <img src="../../assets/image/topic/right.png" alt="">
            </p>
          </div>
          <div class="commentCollection">
            <img src="../../assets/image/topic/collection.png" alt="">
            <span>{{b.like_number}}</span>
          </div>
        </div>
        <WxOpenTag ref="wxopentag" :extinfo="'topicPost/detail?id=' + tid"/>
      </div>
    </div>

    <div class="topicBtn">
      <div class="partakeBtn">
        <span> 关注话题 </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + invitationInfo.topic_id" />
      </div>
      <div class="partakeBtn">
        <span> 赞同TA </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + invitationInfo.topic_id" />
      </div>
      <div class="partakeBtnOne">
        <span> 参与话题 </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + invitationInfo.topic_id" />
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import ShareHeader from '@/components/HeadModule'
  import WxOpenTag from '@/components/WxOpenTag'
  import WxShare from '@/utils/wxshare';
  import {pagebase} from '@/utils/http.js';

  export default {
    data() {
      return {
        tid: this.$route.query.tid || '',
        topicInfo: [],
        cardShow: 0,
        topicInfoText: '',
        invitationInfo: [],
        cur: 0,
        moreBtn: 1,
        commentInfon: [],
        shadeShow: 0,
        supplement: '',
        content: '',

        show: false,
        articleBtnShow: true,
        pagebase: pagebase,
      }
    },
    components: {
      ShareHeader,
      WxOpenTag,
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.getTopicData();
        this.getCommentData();
      },

      getTopicData() {
        this.$http({
          url: '/eleom/topicPostDetail',
          method: 'get',
          params: {
            topic_post_id: this.tid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.topicInfo = res.data.topic_info;

            this.invitationInfo = res.data;

            new WxShare().share({
              title: this.topicInfo.topic_name,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.topicInfo.avatar,
            })
            
            this.txtHeight();

            this.supplement = utils.checkTopicLink(this.topicInfo.supplement)
            this.content = utils.checkTopicLink(this.invitationInfo.content)

            this.$nextTick(() => {
              let $links = document.querySelectorAll('.urlMod')
              $links.forEach(item => {
                item.addEventListener('click', e => {
                  let target = e.target
                  let reg = /^(http|https):\/\/\S*/;
                  if (reg.test(target.dataset.href)) {
                    location.href = target.dataset.href
                  }
                })
              })
            })
          }
        })
      },

      // 判断文章显示高度
      txtHeight() {
        const targetNode = document.getElementById('topicContent');
        const config = {
          attributes: true,
          childList: true,
          subtree: true
        };
        
        const callback = function(mutationsList) {
          for (let mutation of mutationsList) {
            if (mutation.target.scrollHeight > 300) {
              this.show = false;
              this.articleBtnShow = true;
            } else {
              this.show = true;
              this.articleBtnShow = false;
            }
          }
        };
        
        // 创建一个观察器实例并传入回调函数
        const observer = new MutationObserver(callback);
        
        // 以上述配置开始观察目标节点
        observer.observe(targetNode, config);
        
        // 之后，可停止观察
        observer.disconnect();
      },

      // 评论
      getCommentData() {
        this.$http({
          url: '/eleom/topicPostCommentList',
          method: 'get',
          params: {
            page: '1',
            topic_post_id: this.tid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.commentInfon = res.data;
          }
        })
      },
      // 阅读全文按钮
      articleBtn() {
        this.show = true;
        this.articleBtnShow = false;
      },

      // 按钮
      showCard() {
        this.cardShow = 1;
      },
      packUp() {
        this.cardShow = 0;
      },
      postMore() {
        this.moreBtn = 0;
        this.cur = 1;
        this.shadeShow = 1;
      },
      closeShade() {
        this.shadeShow = 0;
      }
    },
  }
</script>

<style lang="css" scoped>
  .topicPost {
    box-sizing: border-box;
    padding-bottom: 7.5rem;
  }

  .topicCard {
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding: 2rem 1.5rem;
  }

  .topicTitle {
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
  }

  .topicConAll {
    position: relative;
    box-sizing: border-box;
    margin-top: 1.4rem;
    border-radius: .8rem;
    font-size: 1.4rem;
    color: #606972;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .topicContent {
    max-height: 34rem;
    overflow: hidden;
  }

  .topicContent>>>img {
    width: 100% !important;
    border-radius: .8rem;
    margin: 1rem 0;
  }

  .topicContentShow {
    max-height: none;
  }

  .showArticle {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5rem;
    background-color: red;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    text-align: center;
    color: #F7443F;
    display: flex;
    align-items: end;
    justify-content: center;
    /* margin-top: -4rem; */
  }

  .showArticle img {
    width: 1.2rem;
    height: 1.2rem;
    padding-bottom: .2rem;
    padding-left: .2rem;
  }

  .topicFounder {
    display: flex;
    align-items: center;
    margin-top: 2rem;
  }

  .founderHeader {
    position: relative;
  }

  .founderHeader img {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .founderName {
    font-size: 1.2rem;
    color: #3F454B;
    margin-right: .2rem;
  }

  .founderTexe {
    font-size: 1.2rem;
    color: #808598;
    margin-left: .2rem;
  }

  .likeNum {
    display: flex;
    align-items: center;
    margin-top: 1rem;
  }

  .likeNum span {
    color: #C0C4CC;
  }

  .followingNum,
  .joinNum,
  .viewNum {
    font-size: 1.2rem;
    color: #1D2023;
    margin-left: .5rem;
  }

  .likeText {
    margin: 0 .5rem;
  }

  /* 帖子 */
  .postCon {
    width: 100%;
    margin-top: .8rem;
    background-color: red;
  }

  .allTopicNum {
    height: 4.4rem;
    font-size: 1.4rem;
    color: #1D2023;
    box-sizing: border-box;
    padding: 1.2rem 1.5rem;
    background-color: #FFFFFF;
  }

  .singleTopicCon {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    background-color: #FFFFFF;
  }

  .userInformation {
    display: flex;
    align-items: center;
  }

  .userHeader {
    position: relative;
  }

  .userHeader img {
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .userText {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .userName {
    font-size: 1.4rem;
    color: #1D2023;
  }

  .userTime {
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .postSingleCon {
    margin-top: 1.5rem;
    height: 17rem;
    overflow: hidden;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .postSingleCon>>>img {
    width: 100%;
  }

  .postSingleCon>>>.urlMod {
    height: 82px;
    box-sizing: border-box;
    background-color: #F2F4F5;
    border-radius: 10px;
    padding: 12px;
    display: flex;
    margin: 10px 0;
    justify-content: space-between;
  }

  .postSingleCon>>>.urlText {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .postSingleCon>>>.urlTitle {
    font-size: 14px;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .postSingleCon>>>.urlUrl {
    font-size: 12px;
    color: #30ABFF;
    display: flex;
    align-items: flex-end;
  }

  .postSingleCon>>>.urlUrl img {
    width: 12px;
    height: 12px;
    margin-bottom: 1.5px;
  }

  .postSingleCon>>>.urlIcon {
    width: 58px;
    height: 58px;
    background-color: #E8E9EB;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
  }

  .postSingleCon>>>.urlIcon img {
    width: 30px;
    height: 30px;
  }

  .allPost {
    overflow: auto;
    height: 100%;
  }

  .postMore {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 34.5rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    box-shadow: 0 -5px 3px -1px rgba(192, 196, 204, 0.3);
    font-size: 1.6rem;
    color: #F5A623;
    background-color: #FFFFFF;
  }

  .topicBtn {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 1.3rem;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    height: 7.5rem;
    background-color: #FFF;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.07);
  }

  .partakeBtnOne {
    position: relative;
    width: 8.5rem;
    height: 3.1rem;
    border-radius: 3.1rem;
    background-color: #F7443F;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    margin-left: 1.25rem;
    color: #FFFFFF;
  }

  .partakeBtn {
    position: relative;
    width: 8.5rem;
    height: 3.1rem;
    border-radius: 3.1rem;
    background-color: #FFE8E7;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    margin-left: 1.25rem;
    color: #F7443F;
  }

  /* 遮罩 */
  .shadeMod {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }

  .callAppMod {
    position: absolute;
    left: 0;
    bottom: 7.5rem;
    background-color: #FFFFFF;
    width: 100%;
    height: 26rem;
    border-radius: 1.5rem 1.5rem 0 0;
  }

  .closeBtn {
    position: absolute;
    right: 2rem;
    top: 2rem;
    width: 2.4rem;
    height: 2.4rem;
  }

  .shadeCon {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .shadeCon img {
    width: 12rem;
    margin-top: 3.2rem;
  }

  .shadeCon p {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .callAppBtn {
    position: relative;
    width: 28rem;
    height: 4.5rem;
    border: none;
    background-color: #F7443F;
    -webkit-tap-highlight-color: transparent;
    border-radius: 2.25rem;
    color: #FFFFFF;
    font-size: 1.8rem;
    margin-top: 3.5rem;
  }

  /* 评论 */
  .commentCon {
    box-sizing: border-box;
    padding: 16px 15px;
    background-color: #FFFFFF;
  }

  .commentAll {
    border-top: .05rem solid #C0C4CC;
    padding-top: 1.6rem;
  }

  .commentText {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1D2023;
  }

  .commentLength {
    margin-left: .6rem;
    font-size: 1.1rem;
    color: #606972;
  }

  .commentHeader {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 1rem;
  }

  .commentList {
    position: relative;
    display: flex;
    padding-top: 1.6rem;
  }

  .commentAllCon {
    width: 100%;
    margin-left: 1rem;
    border-bottom: .05rem solid #E4E7ED;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.6rem;
  }

  .conLeft {}

  .commentTitle {
    font-size: 1.4rem;
    color: #9CA3A9;
  }

  .commentContent {
    word-break: break-all;
    font-size: 1.4rem;
    color: #1D2023;
    margin-top: .4rem;
  }

  .commentReply {
    margin-top: .6rem;
  }

  .commentTime {
    font-size: 1.2rem;
    color: #9CA3A9;
  }

  .commentTimeText {
    font-size: 1.2rem;
    color: #1D2023;
  }

  .commentElse {
    position: relative;
    font-size: 1.2rem;
    color: #808598;
    margin-top: 1.3rem;
  }

  .commentElse img {
    width: 1rem;
    margin-left: .3rem;
  }

  .commentCollection {
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.2rem;
    color: #606972;
  }

  .commentCollection img {
    width: 2rem;
    height: 2rem;
  }

  .callApp {
    position: relative;
    width: 34.5rem;
    height: 3.5rem;

    line-height: 3.5rem;
    text-align: center;
    color: #FFFFFF;
    background-color: #F7443F;
    margin: 0 auto;
  }
</style>